module.exports = __webpack_public_path__ + "static/media/Crawdaunt_gaussian2.a45920ba.png";